import {
  ESTIMATED_AVERAGE_TICKET_OPTIONS,
  ESTIMATED_MONTHLY_VOLUME_OPTIONS,
  EstimatedAverageTicket,
  EstimatedMonthlyVolume,
} from '../constants/estimated-monthly-volume-options';

export const getMonthlyVolumeKeyFromBounds = (
  lowerBound: number,
  upperBound: number | null
): EstimatedMonthlyVolume | undefined => {
  if (lowerBound === 250000 && !upperBound) return '250000';

  const match = ESTIMATED_MONTHLY_VOLUME_OPTIONS.find(key => {
    const [low, high] = key.split('-').map(Number);
    if (key === '250000') return false;
    return low === lowerBound && high === upperBound;
  });

  return match;
};

export const getAverageTicketKeyFromBounds = (
  lowerBound: number,
  upperBound: number | null
): EstimatedAverageTicket | undefined => {
  if (lowerBound === 1000 && !upperBound) return '1000';

  const match = ESTIMATED_AVERAGE_TICKET_OPTIONS.find(key => {
    const [low, high] = key.split('-').map(Number);
    if (key === '1000') return false;
    return low === lowerBound && high === upperBound;
  });

  return match;
};
